// Retrieves user's preferred theme from localStorage or system preferences
export const getPreferredTheme = () => {
  const storedTheme = localStorage.getItem('theme');
  if (storedTheme && storedTheme !== 'auto') {
    return storedTheme;
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const setTheme = (theme) => {
  if (theme === 'auto') {
    document.documentElement.setAttribute(
      'data-bs-theme',
      window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    );
    localStorage.setItem('theme', 'auto');
  } else {
    document.documentElement.setAttribute('data-bs-theme', theme);
    localStorage.setItem('theme', theme);
  }
  updateThemeIcon(theme);
  updateDropdownActive(theme);
};

export const updateThemeIcon = (theme) => {
  const icon = document.querySelector('#theme-toggle i');

  if (!icon) return;

  // Ensure base classes are present
  icon.classList.add('bi', 'theme-icon-active');

  // Remove possible variant classes before adding the correct one
  icon.classList.remove('bi-moon-stars-fill', 'bi-sun-fill', 'bi-circle-half');

  if (theme === 'dark') {
    icon.classList.add('bi-moon-stars-fill');
  } else if (theme === 'light') {
    icon.classList.add('bi-sun-fill');
  } else {
    icon.classList.add('bi-circle-half');
  }
};

export const updateDropdownActive = (theme) => {
  const items = document.querySelectorAll('[data-bs-theme-value]');
  items.forEach((item) => {
    const check = item.querySelector('.bi-check2');
    if (
      item.getAttribute('data-bs-theme-value') === theme ||
      (theme === 'auto' && item.getAttribute('data-bs-theme-value') === 'auto')
    ) {
      item.classList.add('active');
      if (check) check.classList.remove('d-none');
    } else {
      item.classList.remove('active');
      if (check) check.classList.add('d-none');
    }
  });
};

export const darkMode = () => {
  // Apply user's preferred theme on load
  setTheme(localStorage.getItem('theme') || 'auto');

  // Listen for dropdown selection
  document.querySelectorAll('[data-bs-theme-value]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const value = btn.getAttribute('data-bs-theme-value');
      setTheme(value);
    });
  });

  // Listen for system theme changes if auto
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if ((localStorage.getItem('theme') || 'auto') === 'auto') {
      setTheme('auto');
    }
  });
};
